import { Modal, Typography } from "@sunrun/experience-ui-components";

type AppointmentActionErrorModalProps = {
  testId: string;
  title: string;
  description: string;
  onRetry: () => void;
  onDismiss: () => void;
};

const AppointmentActionErrorModal: React.FC<
  AppointmentActionErrorModalProps
> = ({ testId, title, description, onRetry, onDismiss }) => (
  <Modal
    testId={testId}
    type="error"
    title={title}
    primaryButton={{
      text: "Retry",
      onClick: onRetry,
    }}
    secondaryButton={{
      text: "Cancel",
      onClick: onDismiss,
    }}
    onClose={onDismiss}
  >
    <Typography>{description}</Typography>
  </Modal>
);

export { AppointmentActionErrorModal };
export type { AppointmentActionErrorModalProps };
